import React, { useMemo, useState } from "react";
import notificationBellIcon from "../images/notification-active-icon.svg";
import closeIcon from "../images/CancelIcon.svg";
import infoIcon from "../images/infoIcon.svg";
import warningIcon from "../images/warning-orange-icon.svg";
import errorIcon from "../images/warning-red-icon.svg";
import MLRGreen from "../images/MLR-GreenTick.svg";
import VeevaIcon from "../images/Veeva-Icon.svg";
import NoNotifications from "../images/No_Template_Found_Icon.svg";
import "../css/Notification.scss";
import { convertInDate } from "../utils";
import { markAsRead } from "../services/apis";
import { showErrorToast } from "./toastComponent/ToastComponent";

const getStatusClass = (status) => {
  if (status === "in_progress") return "in-progress";
  return status;
};

const NotificationCard = ({ notification, setNotifications }) => {
  const { _id, title, created_at, message, status, unread, docNumber, name, veevaLink } = notification;

  const statusIcon =
    status === "failed"
      ? errorIcon
      : status === "in_progress"
        ? warningIcon
        : infoIcon;

    const handleMarkRead = async() => {
      if(!unread) return;
      setNotifications(pre => pre.map(n => n._id === _id ? {...n, unread: false} : n));
      await markAsRead(_id, (response, error) => {
        if(error) {
          showErrorToast(JSON.stringify(error.response.data.err || "Failed to mark as read"));
        }
      });
    }

  return (
    <div 
        className={`notification-card${unread ? " unread" : ""}`}
        onClick={handleMarkRead}
    >
        <div className="header">
            <span className="title">{title}</span>
            <span className="timestamp">{ convertInDate(created_at, "hrs")}</span>
        </div>

        <div className={`message ${getStatusClass(status)}`}>
            <img src={statusIcon} alt="" className="message-icon" />
            <p className="message-text">{message}</p>
        </div>

        <div className="footer">
            <div className="footer-mlr-status">
                <img src={MLRGreen} alt="" className="footer-status-icon" />
                <span className="footer-doc-number">{docNumber}</span>
                <a href={veevaLink} target="_blank" rel="noopener noreferrer" style={{cursor: "pointer"}}>
                    <img src={VeevaIcon} alt="" className="footer-veeva-icon" />
                </a>
            </div>

            <div>
                <span className="footer-name">Name: </span>
                <span className="footer-name-value">{name}</span>
            </div>
        </div>
    </div>
  );
};

const Notification = ({ setOpenNotification, notifications, setNotifications, unreadCount }) => {
  const [showUnreadOnly, setShowUnreadOnly] = useState(false);

  const displayedNotifications = useMemo(() => {
    if (showUnreadOnly) {
      return notifications.filter((n) => n.unread);
    }
    return notifications;
  }, [notifications, showUnreadOnly]);

  const handleClose = () => setOpenNotification(false);

  const handleMarkAllRead = async () => {
    setNotifications((prev) => prev.map((n) => ({ ...n, unread: false })));
    await markAsRead(null, (response, error) => {
      if(error) {
        showErrorToast(JSON.stringify(error.response.data.err || "Failed to mark as read"));
      }
    });
  };

  const handlePanelClick = (e) => e.stopPropagation();

  return (
  <div
    className="notification-drawer"
    role="dialog"
    aria-modal="true"
    aria-label="Notifications"
  >
    <div className="backdrop" aria-hidden="true" />
        <aside className="panel" onClick={handlePanelClick}>

            <div className="notification-header">
                <div className="header-row">
                    <div className="image-label">
                        <img
                            src={notificationBellIcon}
                            alt=""
                            className="bell"
                            width={16}
                            height={16}
                        />
                    </div>
                    <h2 className="title">NOTIFICATIONS</h2>
                    <img src={closeIcon} alt="" width={22} height={22} className="close-btn"  onClick={handleClose}/>
                </div>

                <div className="header-row">
                    <span className="label-text"> Unread Notifications {unreadCount > 0 ? `(${unreadCount})` : ""}</span>
                    <label className="toggle">
                        <input
                            type="checkbox"
                            checked={showUnreadOnly}
                            onChange={(e) => setShowUnreadOnly(e.target.checked)}
                        />
                        <span className="toggle toggle-switch switch-round" />
                    </label>
                </div>
            </div>

            <div className="notification-subhead">
                <span className="count">All ({displayedNotifications.length})</span>
                <div className={`mark-all ${unreadCount === 0 ? "disabled" : ""}` } onClick={handleMarkAllRead}> Mark all as Read </div>
            </div>


        <div className="list">
          {displayedNotifications.length === 0 ? (
            <div className="empty-state">
                <img src={NoNotifications} alt="No notifications" className="no-notifications-img" />
                <p className="no-notifications-text">You’ve reviewed all your notifications from the past 30 days.</p>
            </div>
          ) : (
            displayedNotifications.map((notification) => (
              <NotificationCard key={notification.id} notification={notification} setNotifications={setNotifications} />
            ))
          )}
        </div>
      </aside>
    </div>
  );
};

export default Notification;